import customFetch from "./axio";

export interface TenantVerificationPayload {
  transaction?: string;
  dateOfBirth: string;
  employmentStatus: string;
  workAddress: string;
  incomeRange: string;
  guarantor: { name: string; relationship: string; phone: string; email: string; address: string };
  officeGuarantor: { companyName: string; name: string; jobTitle: string; phone: string; email: string; address: string };
}

export function verificationIsActive(data: any): boolean | null {
  if (data == null || (typeof data === "object" && Object.keys(data).length === 0)) return false;
  if (typeof data.isActive === "boolean") return data.isActive;
  if (typeof data.active === "boolean") return data.active;
  if (typeof data.status === "string") {
    if (["active", "approved", "verified"].includes(data.status)) return true;
    if (["inactive", "pending", "rejected", "expired", "not_started", "pending_review", "under_review"].includes(data.status)) return false;
  }
  return null;
}

export async function getTenantVerification(signal?: AbortSignal) {
  const response = await customFetch.get("/rent/verifications/me", { signal });
  if (response.data?.success === false) throw new Error(response.data.errors?.[0]?.message || response.data.message || "Could not check tenant verification.");
  return response.data.data;
}

export async function submitTenantVerification(
  payload: TenantVerificationPayload,
  documents: { proofOfEmployment: File; proofOfIncome: File | null },
) {
  const body = new FormData();
  body.append("dateOfBirth", payload.dateOfBirth);
  body.append("employmentStatus", payload.employmentStatus === "self_employed" ? "self-employed" : payload.employmentStatus);
  body.append("workAddress", payload.workAddress);
  body.append("incomeRange", payload.incomeRange);
  body.append("guarantor", JSON.stringify(payload.guarantor));
  body.append("officeGuarantor", JSON.stringify(payload.officeGuarantor));
  body.append("proofOfEmployment", documents.proofOfEmployment);
  if (documents.proofOfIncome) body.append("proofOfIncome", documents.proofOfIncome);
  if (payload.transaction) body.append("transaction", payload.transaction);
  const response = await customFetch.post("/rent/verifications", body);
  if (response.data?.success === false) throw new Error(response.data.message || "Could not submit tenant verification.");
  return response.data.data;
}
